import { render, staticRenderFns } from "./SignatureField.vue?vue&type=template&id=f9b4871c&scoped=true&"
import script from "./SignatureField.vue?vue&type=script&lang=js&"
export * from "./SignatureField.vue?vue&type=script&lang=js&"
import style0 from "./SignatureField.vue?vue&type=style&index=0&id=f9b4871c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b4871c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9b4871c')) {
      api.createRecord('f9b4871c', component.options)
    } else {
      api.reload('f9b4871c', component.options)
    }
    module.hot.accept("./SignatureField.vue?vue&type=template&id=f9b4871c&scoped=true&", function () {
      api.rerender('f9b4871c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/SignatureField.vue"
export default component.exports